class Quotebar extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector(".quote-bar-slider");
    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 24,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          centeredSlides: true,
          loop: true,
        },
        540: {
          slidesPerView: 3,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        991: {
          slidesPerView: 5,
          centeredSlides: false,
        }
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("quote-bar")) {
  customElements.define("quote-bar", Quotebar);
}